export const PRICING = Object.freeze({
  MEMBERSHIP_MONTHLY_RANDS: 50,
  TAG_ONCE_OFF_RANDS: 250,
});

